module.exports = __webpack_public_path__ + "static/media/bulk_master_oda.db2cffb8.csv";